import axios from '../axios'

// 获取appid
export const getClassList = (data) => {
  return axios({
    url: '/applet/t/mc/hc/getClassList',
    method: 'GET',
    data
  })
}
// 教师查看班级成员提交情况列表
export const getStudentHomeworkList = (data) => {
  return axios({
    url: '/applet/t/mc/hc/getStudentHomeworkList',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/classSituation.js